import { render, staticRenderFns } from "./ResultsByMatrixCard.vue?vue&type=template&id=38a4f94b&scoped=true&"
import script from "./ResultsByMatrixCard.vue?vue&type=script&lang=js&"
export * from "./ResultsByMatrixCard.vue?vue&type=script&lang=js&"
import style0 from "./ResultsByMatrixCard.vue?vue&type=style&index=0&id=38a4f94b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a4f94b",
  null
  
)

export default component.exports